import { AnglesLeft } from './AnglesLeft';
import { AnglesRight } from './AnglesRight';
import { Home } from './Home';
import { CheckBox } from './CheckBox';
import { File } from './File';
import { Expand } from './Expand';
import { Decision } from './Decision';
import { Decision20 } from './Decision20';
import { Risks } from './Risks';
import { Risks20 } from './Risks20';
import { Issues } from './Issues';
import { Issues20 } from './Issues20';
import { RightArrow } from './RightArrow';
import { People } from './People';
import { ExpandUpper } from './ExpandUpper';
import { Add } from './Add';
import { QuestionMark } from './QuestionMark';
import { Settings } from './Settings';
import { ChevronUp } from './ChevronUp';
import { Drag } from './Drag';
import { Watch } from './Watch';
import { NoTask } from './NoTask';
import { Calendar } from './Calendar';
import { PeopleGroup } from './PeopleGroup';
import { Vector } from './Vector';
import { SubTaskIcon } from './SubTaskIcon';
import { UnionIcon } from './UnionIcon';
import { History } from './History';
import { Delete } from './Delete';
import { Cancel } from './Cancel';
import { Dependency } from './Dependency';
import { DealspaceBook } from './DealspaceBook';
import { Flag } from './Flag';
import { HelpOutline } from './HelpOutline';
import { FlagFilled } from './FlagFilled';
import { Hammer } from './Hammer';
import { Box } from './Box';
import { LogoBlue } from './LogoBlue';
import { Rename } from './Rename';
import { Duplicate } from './Duplicate';
import { Union } from './Union';
import { Delete2 } from './Delete2';
import { BaselineSwapVert } from './BaselineSwapVert';
import { Comment } from './Comment';
import { AlignLeft } from './AlignLeft';
import { AssignedToMe } from './AssignedToMe';
import { ChevronDown } from './ChevronDown';
import { ChevronRight } from './ChevronRight';
import { Check } from './Check';
import { Ring } from './Ring';
import { Description } from './Description';
import { Milestone } from './Milestone';
import { Diamond } from './Diamond';
import { DiamondChecked } from './DiamondChecked';
import { RiskHeader } from './RiskHeader';
import { IssuesHeader } from './IssuesHeader';
import { DecisionHeader } from './DecisionHeader';
import { DependencyHeader } from './DependencyHeader';
import { Doc } from './Doc';
import { Pdf } from './Pdf';
import { Xls } from './Xls';
import { Download } from './Download';
import { Remove } from './Remove';
import { Transfer } from './Transfer';
import { EditPencil } from './EditPencil';
import { CheckIcon } from './CheckIcon';
import { ErrorIcon } from './ErrorIcon';
import { Png } from './Png';
import { InfoClock } from './InfoClock';
import { InfoFile } from './InfoFile';
import { InfoPerson } from './InfoPerson';
import { InfoRid } from './InfoRid';
import { Attachment } from './Attachment';
import { NoItem } from './NoItem';
import { ArrowDown } from './ArrowDown';
import { ColorfulDelete } from './ColorfulDelete';
import { LoadingScreen } from './LoadingScreen';
import { Archive } from './Archive';
import { WindowMinimize } from './WindowMinimize';
import { ShareAlt } from './ShareAlt';
import { DownArrow } from './DownArrow';
import { Calendar2 } from './Calendar2';
import { Knowledge } from './Knowledge';
import { Menu } from './Menu';
import { Workplan } from './Workplan';
import { Unfold } from './Unfold';
import { CollapseUpper } from './CollapseUpper';
import { DiamondFilled } from './DiamondFilled';
import { BoxOutlined } from './BoxOutlined';
import { ToogleOff } from './ToogleOff';
import { Dashboard } from './Dashboard';
import { DashboardNav } from './DashboardNav';
import { Verified } from './Verified';
import { Link } from './Link';
import { RedTrash } from './RedTrash';
import { DealRing } from './DealRing';
import { CloudDownload } from './CloudDownload';
import DependencyIn from './DependencyIn';
import DependencyOut from './DependencyOut';
import { ArrowOutward } from './ArrowOutward';
import { DecisionNew } from './DecisionNew';
import { SourceDeleted } from './SourceDeleted';
import RiskImpact from './RiskImpact';
import Pptx from './Pptx';
import VideoPreview from './VideoPreview';
import { TrendingDown } from './TrendingDown';
import { FreeFrom } from './FreeFrom';
import { EmptyFreeBk } from './EmptyFreeBk';
import { HandShake } from './HandShake';
import { EmptyDealBk } from './EmptyDealBk';
import { Accomplishments } from './Accomplishments';
import { EmptyAccomplishments } from './EmptyAccomplishments';
import { ViewColumn } from './ViewColumn';
import { SearchIcon } from './SearchIcon';
import { HeroIcon } from './HeroIcon';
import { Minus } from './Minus';
import { Arrow } from './Arrow';
import { Templates } from './Templates';
import { Person } from './Person';
import { DeleteFilled } from './DeleteFilled';
import { Description2 } from './Description2';
import { CloudUpload } from './CloudUpload';
import { AddTemplates } from './AddTemplates';
import { Move } from './Move';
import { DateConflict } from './DateConflict';
import { LogoIcon } from './LogoIcon';
import { TrialPlanIcon } from './TrialPlanIcon';
import { Lightbulb } from './Lightbulb';
import { CurrencyExchange } from './CurrencyExchange';
import { Polygon } from './Polygon';
import { Ticket } from './Ticket';
import { KeyboardReturn } from './KeyboardReturn';
import { Pause } from './Pause';
import { Logout } from './Logout';
import { FreeWarn } from './FreeWarn';
import { Info } from './Info';
import { BookshelfLogo } from './BookshelfLogo';
import { FolderThin } from './FolderThin';
import AddTask from './AddTask';
import AssingTeammate from './AssingTeammate';
import SetDueDate from './SetDueDate';
import BoardArrow from './BoardArrow';
import CheckElement from './CheckElement';
import { Undo } from './Undo';
import { Send } from './Send';
import { EmptyMessage } from './EmptyMessage';
import { EmptyAiDocument } from './EmptyAiDocument';
import { UndoGradient } from './UndoGradient';
import { Star } from './Star';

export type IconProps = {
  className?: string;
  color?: string;
  width?: string;
  height?: string;
};

export const Icons = {
  UndoGradient,
  EmptyAiDocument,
  EmptyMessage,
  Send,
  Undo,
  Star,
  AddTask,
  SetDueDate,
  AssingTeammate,
  BoardArrow,
  BookshelfLogo,
  Minus,
  HeroIcon,
  Logout,
  FreeWarn,
  Info,
  SearchIcon,
  ViewColumn,
  Polygon,
  Move,
  Templates,
  Arrow,
  LogoIcon,
  Lightbulb,
  EmptyAccomplishments,
  KeyboardReturn,
  Accomplishments,
  EmptyDealBk,
  HandShake,
  EmptyFreeBk,
  FreeFrom,
  Ticket,
  CurrencyExchange,
  TrendingDown,
  Link,
  ToogleOff,
  BoxOutlined,
  CheckElement,
  DealRing,
  CollapseUpper,
  RedTrash,
  Calendar2,
  ExpandUpper,
  DownArrow,
  ShareAlt,
  WindowMinimize,
  ArrowDown,
  Png,
  Download,
  Attachment,
  ArrowOutward,
  Pdf,
  Doc,
  Xls,
  Check,
  AlignLeft,
  Diamond,
  DiamondChecked,
  Comment,
  BaselineSwapVert,
  Delete2,
  Union,
  Duplicate,
  SourceDeleted,
  Rename,
  Hammer,
  Box,
  FlagFilled,
  SubTaskIcon,
  Vector,
  PeopleGroup,
  Calendar,
  AnglesLeft,
  AnglesRight,
  Home,
  CheckBox,
  AssignedToMe,
  File,
  Expand,
  Decision,
  Risks,
  Issues,
  Decision20,
  Risks20,
  Issues20,
  RightArrow,
  People,
  Add,
  QuestionMark,
  Settings,
  ChevronUp,
  Drag,
  Watch,
  NoTask,
  UnionIcon,
  History,
  Delete,
  Cancel,
  Dependency,
  DealspaceBook,
  Flag,
  HelpOutline,
  LogoBlue,
  ChevronDown,
  ChevronRight,
  Ring,
  Description,
  Milestone,
  RiskHeader,
  IssuesHeader,
  DependencyHeader,
  DecisionHeader,
  Remove,
  Transfer,
  EditPencil,
  CheckIcon,
  ErrorIcon,
  NoItem,
  ColorfulDelete,
  LoadingScreen,
  Archive,
  Knowledge,
  Menu,
  Workplan,
  Unfold,
  DiamondFilled,
  Dashboard,
  DashboardNav,
  Verified,
  CloudDownload,
  DependencyIn,
  DependencyOut,
  DecisionNew,
  RiskImpact,
  Pptx,
  InfoClock,
  TrialPlanIcon,
  InfoFile,
  InfoPerson,
  InfoRid,
  VideoPreview,
  Pause,
  Person,
  DeleteFilled,
  Description2,
  CloudUpload,
  AddTemplates,
  DateConflict,
  FolderThin,
};
